import { render, staticRenderFns } from "./Yonhuzhuce.vue?vue&type=template&id=39aa8664&scoped=true"
import script from "./Yonhuzhuce.vue?vue&type=script&lang=js"
export * from "./Yonhuzhuce.vue?vue&type=script&lang=js"
import style0 from "./Yonhuzhuce.vue?vue&type=style&index=0&id=39aa8664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39aa8664",
  null
  
)

export default component.exports